import { PtcldScriptContextProvider, usePtcldScriptContext } from "contexts/PtcldScriptContext";

import PointCloudViewerContent from "containers/ComparePointCloudVirtualTour/components/pointcloud/PointCloudViewerContent";
import { useSearchParams } from "react-router-dom";
import { useGetScanQuery } from "api/scan/queries/useGetScanQuery";

type Props = {
  pointCloudData: PointCloudOutput | undefined;
  dataError: Error | null;
};

export default function PointCloudViewer({ pointCloudData, dataError }: Props) {
  return (
    <PtcldScriptContextProvider>
      <PointCloudViewerContent pointCloudData={pointCloudData} dataError={dataError} />
    </PtcldScriptContextProvider>
  );
}
